export const KYC_REDIRECT_URL = "KYC_REDIRECT_URL";

export interface SetRedirectURL {
  type: typeof KYC_REDIRECT_URL;
  payload: {
    redirectUrl?: string;
  };
}

export type KYCDispatchType = SetRedirectURL;
